// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1___3519981b585928cdec0","cls2":"CoreXNav-cls2__c06bd34203506ce48ee5 CoreXNav-cls1___3519981b585928cdec0","inDevStyle":"CoreXNav-inDevStyle__e96f80b85843a953b565"};